// extracted by mini-css-extract-plugin
export var title = "formMain-module--title--pFUHK";
export var headline = "formMain-module--headline--3S20Q";
export var formContainer = "formMain-module--formContainer--QvWtp";
export var link = "formMain-module--link--2pefJ";